import { Icon } from '@/src/tools/icon';
import React from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { SectionCollapse, SizeFittingTable } from 'src/components/Antd';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const VirtualStock = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { products } = props;
  const h = useHistory();
  const col = [
    {
      width: 32,
      default: true,
      title: '',
      key: 'index',
      childGenerate: (_, __, index: number) => index + 1,
    },
    {
      title: getI18n('general.storeCommunicationSetting.product'),
      dataIndex: 'Product',
      default: true,
      optional: true,
      key: 'Product',
      //className: css.columnClass,
      minWidth: 450,
      childGenerate: (text, record, index) => {
        const { name } = record;
        return (
          <div className={css.nameContainer}>
            <NoWrapContainer>
              <GlobalTooltip title={name}>{name}</GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },
    },
    {
      title: getI18n('salesChannelProductDetail.index.availableQuantity'),
      dataIndex: 'Quantity',
      default: true,
      optional: true,
      key: 'Quantity',
      //className: css.columnClass,
      minWidth: 450,
      childGenerate: (text, record, index) => {
        const { stockAvailableUnlimited, stockAvailable } = record;
        return stockAvailableUnlimited ? '-' : stockAvailable;
      },
    },
    {
      title: '',
      dataIndex: 'action',
      default: true,
      optional: true,
      key: 'action',
      //className: css.columnClass,
      minWidth: 128,
      childGenerate: (text, record, index) => {
        const { uuid } = record;
        return (
          <div
            className={css.gotoProduct}
            onClick={() => {
              h.push(`/product/virtualProduct/${uuid}`);
            }}>
            {getI18n('salesChannelProductDetail.index.gotoProduct')}
          </div>
        );
      },
    },
  ];
  const renderTitle = () => {
    return (
      <div className={css.title}>
        <div className={'collapseTitle'}>
          {getI18n('general.hOCTitle.quantity')}
        </div>
      </div>
    );
  };
  const renderContent = () => {
    return (
      <React.Fragment>
        <div className={css.container}>
          <SizeFittingTable
            pagination={false}
            dataSource={products}
            id={`SalesChannelLinkProductVirtualStockTable`}
            columns={col}
            rowKey={'uuid'}
          />
        </div>{' '}
        <div className={css.bottomContainer}> {renderBottom()}</div>
      </React.Fragment>
    );
  };
  const renderBottom = () => {
    return (
      <div className={css.bottom}>
        <Icon type='iconinfo' className={css.icon} />
        <span>
          {`${getI18n('general.gotoStore')} > `}
          <Link to={'/productsList'}>
            {getI18n('general.storeCommunicationSetting.product')}
          </Link>
          {' to manage quantity.'}
        </span>
      </div>
    );
  };

  return (
    <SectionCollapse
      open={true}
      id={'salesChannelLinkProductVirtualStockCollapse'}
      titleStyle={{ height: '64px' }}
      title={renderTitle()}
      content={renderContent()}
      openMargin={16}
    />
  );
};
export default VirtualStock;
